import styled, { css } from 'styled-components';

export const ScheduleWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const ScheduleTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ScheduleList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

type Variant = 'success' | 'neutral' | 'danger' | 'info' | 'warning';

const variantStyles = {
    success: css`
    background: #EEF8F1;
    border-color: #D5F0DC;
  `,
    neutral: css`
    background: #F3F5F7;
    border-color: #E7EAEE;
  `,
    danger: css`
    background: #FFF3F3;
    border-color: #FAD7D7;
  `,
    info: css`
    background: #F3F5F7;
    border-color: #E7EAEE;
  `,
    warning: css`
    background: #FFFAF1;
    border-color: #F7E6C3;
  `,
};

export const ScheduleCard = styled.div<{ $variant: Variant }>`
  border-radius: 10px;
  border: 1.5px solid #E7EAEE;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${({ $variant }) => variantStyles[$variant]}
`;

export const ScheduleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ScheduleName = styled.div`
  font-weight: 700;
  color: #223046;
`;

export const CoursePill = styled.span`
  margin-left: 8px;
  background: #F3F4F6;
  color: #223046;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 8px;
`;

export const DetailsButton = styled.button`
  background: transparent;
  border: none;
  color: #7B2639;
  font-weight: 600;
  cursor: pointer;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6B7280;
  font-size: 0.95rem;
`;

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Note = styled.div`
  font-size: 0.9rem;
  color: #7A7F87;
  font-style: italic;
  margin-top: 2px;
`;

